import { Autocomplete, TextField } from '@mui/material';

export interface IEntityOption {
  id: number;
  name: string;
}

interface IEntitySelectorProps {
  options: IEntityOption[];
  value?: number;
  onChange: (id?: number) => void;
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
  loading?: boolean;
  noOptionsText?: string;
  getOptionLabel?: (option: IEntityOption) => string;
  dataTestid?: string;
}

export const EntitySelector: React.FC<IEntitySelectorProps> = ({
  options,
  value,
  onChange,
  label,
  disabled = false,
  fullWidth = true,
  loading,
  noOptionsText,
  getOptionLabel,
  dataTestid,
}) => {
  const selected = options.find(o => o.id === value) || null;

  return (
    <Autocomplete
      key={value !== undefined ? 'selected' : 'not-selected'}
      options={options}
      value={selected}
      fullWidth={fullWidth}
      onChange={(_, v) => onChange(v?.id)}
      getOptionLabel={(opt) => getOptionLabel ? getOptionLabel(opt) : opt.name}
      disabled={disabled || options.length === 0}
      loading={loading}
      noOptionsText={noOptionsText}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant='outlined'
          size='medium'
          {...(dataTestid ? { 'data-testid': dataTestid } : {})}
        />
      )}
    />
  );
};
